import { render, staticRenderFns } from "./VendorsSearch.vue?vue&type=template&id=5760027b&scoped=true"
import script from "./VendorsSearch.vue?vue&type=script&lang=js"
export * from "./VendorsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5760027b",
  null
  
)

export default component.exports